module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/_iterators.js
// module id = 101
// module chunks = 0